/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CryptoRatesResponse } from '../models/CryptoRatesResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RatesService {
    /**
     * Get cryptocurrency exchange rates
     * Retrieve current cryptocurrency exchange rates relative to USDT.ERC20 (fiat reference).
     *
     * Rates are updated every 30 minutes and cached for performance. The response includes
     * exchange rates for all supported cryptocurrencies and a timestamp indicating when
     * the next update will occur.
     *
     * **Real-time Updates**: Subscribe to the SSE endpoint to receive `CRYPTO_RATES_UPDATE`
     * events when rates are refreshed.
     *
     * @returns CryptoRatesResponse Current cryptocurrency exchange rates
     * @throws ApiError
     */
    public static getV1Rates(): CancelablePromise<CryptoRatesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/rates',
            errors: {
                500: `Internal server error`,
            },
        });
    }
}
